// Card #1608 — foxbox (#884's PushStatusReport.cs) encodes a ride's push
// failure as a JSON string: {cause: "locked" | "unknown", attempts: N,
// rawError: "..."}, self-truncated to stay under score-api's exact 2000-char
// `error` cap (a hard 400 on overage, never a server-side truncation, so
// foxbox truncates before sending). Older rows, or any other writer, may
// instead carry a plain non-JSON string. Parse the JSON shape; degrade
// gracefully to { cause: null, attempts: null, rawError: <original string> }
// on anything that isn't exactly that shape, rather than throwing or
// rendering "[object Object]"/blank.
export function parseFvdPushError(raw) {
  if (raw == null) return { cause: null, attempts: null, rawError: null };
  if (typeof raw !== "string") return { cause: null, attempts: null, rawError: String(raw) };

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch {
    return { cause: null, attempts: null, rawError: raw };
  }

  if (!parsed || typeof parsed !== "object" || typeof parsed.rawError !== "string") {
    return { cause: null, attempts: null, rawError: raw };
  }

  const cause = parsed.cause === "locked" || parsed.cause === "unknown" ? parsed.cause : null;
  const attempts = Number.isFinite(parsed.attempts) ? parsed.attempts : null;
  return { cause, attempts, rawError: parsed.rawError };
}

export default parseFvdPushError;
